import React from "react";
import WaveOrb from "./WaveOrb";
import { DEFAULT_PARTY_MOOD_COLOR, partyMoodOrbPalette } from "../utils/partyMoods";

export default function DiscoWaveOrb({
  isPlaying,
  color = DEFAULT_PARTY_MOOD_COLOR,
  colors,
  label = "",
}) {
  const palette = partyMoodOrbPalette(colors && colors.length ? colors : [color]);
  return (
    <WaveOrb
      color={palette[0]}
      colors={palette}
      size={160}
      pulse={isPlaying ? 1.0 : 0}
      label={label}
    />
  );
}
